import { atom } from '@exodus/headless-ui';
const isReadyAtom = atom((get, { selectors }) => {
    const availableAssets = get(selectors.availableAssets.all);
    return Object.values(availableAssets).length > 0;
});
export default isReadyAtom;
